import firstImage from 'App/assets/tutorialCampaign/1.png';
import secondImage from 'App/assets/tutorialCampaign/2.png';
import thirdImage from 'App/assets/tutorialCampaign/3.png';
import fourthImage from 'App/assets/tutorialCampaign/4.png';
import fifthImage from 'App/assets/tutorialCampaign/5.png';

export const tutorialCampaignSteps = [
	{
		title: '¡Bienvenido!',
		description:
			'Antes de empezar te invitamos a conocer las etapas que tendrá tu campaña de NOM-035',
		img: {
			src: firstImage,
			width: 280,
			heigth: 280,
		},
	},
	{
		title: 'Comunicar',
		description: `Comienza programando los principales envíos de comunicación y la evaluación.
		¡Si necesitas enviar más comunicados, podrás hacerlo después sin problema!`,
		img: {
			src: secondImage,
			width: 280,
			heigth: 280,
		},
	},
	{
		title: 'Monitorear',
		description:
			'Podrás monitorear la participación de los colaboradores hasta completar las evaluaciones requeridas',
		img: {
			src: thirdImage,
			width: 280,
			heigth: 280,
		},
	},
	{
		title: 'Analizar',
		description:
			'Analiza los resultados recibidos en las evaluaciones, para entender el estado general de tu plantilla',
		img: {
			src: fourthImage,
			width: 280,
			heigth: 280,
		},
	},
	{
		title: 'Referir',
		description:
			'Identifica a los colaboradores en riesgo e invitarlos a agendar una cita con el médico',
		img: {
			src: fifthImage,
			width: 280,
			heigth: 280,
		},
	},
];
